import EditorRoutes from 'foundation/EditorRoutes';
import {RouteBundle} from 'routing/RouteConstants';

export const LabelPrintingRoutes: RouteBundle = {
  domain: 'label-printing',
  routes: [
    {
      urlPattern: 'label-printing-settings',
      handler: EditorRoutes.tenantLevelLabelPrintingSettings.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: 'inventory-settings',
      handler: EditorRoutes.tenantLevelInventorySettings.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/label-templates/',
      handler: EditorRoutes.labelTemplates.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/label-templates/create',
      handler: labelTemplateSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/label-templates/:labelTemplateId',
      handler: labelTemplateSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/printers/',
      handler: EditorRoutes.printers.bind(EditorRoutes),
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/printers/create',
      handler: printerSettings,
      legacy: true,
    },
    {
      urlPattern: ':ownerUrl/registries/:registryUrlIdentifier/printers/:printerId',
      handler: printerSettings,
      legacy: true,
    },
  ],
};

function labelTemplateSettings(ownerUrlId: string, registryId: string, labelTemplateId?: string): void {
  EditorRoutes.labelTemplateSettings(ownerUrlId, registryId, labelTemplateId);
}

function printerSettings(ownerUrlId: string, registryId: string, printerId?: string): void {
  EditorRoutes.printerSettings(ownerUrlId, registryId, printerId);
}
